import React, { useEffect, useState } from 'react';
import {
  FiDollarSign, FiShoppingBag, FiPackage, FiUsers, FiTag, FiClock,
  FiCheckCircle, FiTrendingUp, FiLayers, FiGrid, FiCalendar, FiStar,
} from 'react-icons/fi';
import { adminApi } from '../adminApi';

function StatCard({ label, value, Icon, color, bg }) {
  return (
    <div className="stat-card" style={{ '--sc': color, '--sb': bg }}>
      <div className="stat-icon-box"><Icon size={20} /></div>
      <div className="stat-info">
        <div className="stat-value">{value}</div>
        <div className="stat-label">{label}</div>
      </div>
    </div>
  );
}

function Dashboard() {
  const [stats,   setStats]   = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.getStats().then(r => setStats(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="admin-loading"><div className="admin-spinner" />Loading…</div>;

  const s = stats;
  const rs = (v) => `Rs ${(v || 0).toLocaleString()}`;

  return (
    <div className="dash-page">

      {/* ── Records ── */}
      <div className="dash-section-label">Records</div>
      <div className="stats-grid stats-grid-4">
        <StatCard label="Categories"      value={s.total_categories    || 0} Icon={FiGrid}        color="#6366f1" bg="#eef2ff" />
        <StatCard label="Sub Categories"  value={s.total_subcategories || 0} Icon={FiLayers}      color="#8b5cf6" bg="#ede9fe" />
        <StatCard label="Products"        value={s.total_products      || 0} Icon={FiPackage}     color="#3b82f6" bg="#dbeafe" />
        <StatCard label="Active Products" value={s.active_products     || 0} Icon={FiStar}        color="#10b981" bg="#d1fae5" />
        <StatCard label="Revenue"         value={rs(s.total_revenue)}       Icon={FiDollarSign}  color="#f59e0b" bg="#fef3c7" />
        <StatCard label="Orders"          value={s.total_orders        || 0} Icon={FiShoppingBag} color="#ec4899" bg="#fce7f3" />
        <StatCard label="Pendings"        value={s.pending_orders      || 0} Icon={FiClock}       color="#ef4444" bg="#fee2e2" />
        <StatCard label="Proceeds"        value={rs(s.delivered_revenue)}   Icon={FiTrendingUp}  color="#14b8a6" bg="#ccfbf1" />
        <StatCard label="Delivered"       value={s.delivered_orders    || 0} Icon={FiCheckCircle} color="#22c55e" bg="#dcfce7" />
        <StatCard label="Customers"       value={s.total_users         || 0} Icon={FiUsers}       color="#0ea5e9" bg="#e0f2fe" />
      </div>

      {/* ── Today Sales ── */}
      <div className="dash-section-label">Today Sales ({s.today_label || '—'})</div>
      <div className="stats-grid stats-grid-4">
        <StatCard label="Sales Amount" value={rs(s.today_sales)} Icon={FiCalendar} color="#f59e0b" bg="#fef3c7" />
      </div>

      {/* ── This Month Sales ── */}
      <div className="dash-section-label">This Month Sales ({s.month_label || '—'})</div>
      <div className="stats-grid stats-grid-4">
        <StatCard label="Sales Amount" value={rs(s.month_sales)} Icon={FiTrendingUp} color="#10b981" bg="#d1fae5" />
      </div>

    </div>
  );
}

export default Dashboard;
